import React, {PureComponent} from "react"
import {Query} from "@irati/utils/services/apollo"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {QueryComponentProps} from "@irati/utils/services/apollo/Query"
import {WellnessCarousel} from "@irati/types"

import getCarouselQuery from "../../services/queries/getCarousel"

export const query = getCarouselQuery

interface Props extends Omit<QueryComponentProps<{getCarousel: WellnessCarousel[]}>, "query"> {}

export default class WellnessBannersCarousel extends PureComponent<Props> {
  render() {
    const {children, ...props} = this.props

    return (
      <Query {...props} query={query}>
        {(apollo: ApolloState) => {
          return this.props.children(apollo)
        }}
      </Query>
    )
  }
}
